import OpenstackMinionPoolSchemaPlugin from "@src/plugins/openstack/MinionPoolSchemaPlugin";

export default class VHIMinionPoolSchemaPlugin extends OpenstackMinionPoolSchemaPlugin {}
